import { useNullableContext } from '~/common/contexts/nullableContext';
import { Module } from '~/core/shared/constants';
import { AppModule } from '../../constants/AppModule';
import { ModuleScopeContext } from '../../ModuleScopeContext';

const NORMALISED_MODULE: Record<AppModule, Module> = {
  [AppModule.BrokerPortal]: Module.BrokerPortal,
  [AppModule.Application]: Module.BrokerPortal,
  [AppModule.MiddleOffice]: Module.MiddleOffice,
};

export const useModuleScope = (): Module => {
  const module = useNullableContext(
    ModuleScopeContext,
    'useModuleScope must be used within a ModuleScopeProvider',
  );
  return NORMALISED_MODULE[module];
};
